import React from "react";

export type TimelineContextType = {
  currentSimulatorTime: Date | null;
  setCurrentSimulatorTime: (t: Date) => void;
  timeAtPageLoad: Date;
};

const TimelineContextDefaults: TimelineContextType = {
  currentSimulatorTime: new Date(),
  setCurrentSimulatorTime: (t: Date) => null,
  timeAtPageLoad: new Date(),
};

const TimelineContext = React.createContext<TimelineContextType>(
  TimelineContextDefaults
);

export default TimelineContext;
